import React from 'react';
import { Link } from 'react-router-dom';
import './ThankYou.css';

const ThankYou = () => {
  return (
    <>
      {/* Thank You Section */}
      <section className="thank-you-section">
        <div className="container">
          <div className="thank-you-content">
            <div className="success-icon">
              <i className="fas fa-check-circle"></i>
            </div>
            <h1>Thank You for Your Interest!</h1>
            <p className="subtitle">Your AI consultation request has been received successfully.</p>
            <p>We're excited to help you transform your business with AI Voice Agents and Chatbots. Our team will review your requirements and get back to you within 24 hours with a personalized consultation.</p>
            
            <div className="next-steps">
              <h2>What Happens Next?</h2>
              <div className="steps-grid">
                <div className="step-item">
                  <div className="step-number">1</div>
                  <div className="step-content">
                    <h3>Review Your Requirements</h3>
                    <p>We'll analyze your business needs and prepare a customized AI solution proposal.</p>
                  </div>
                </div>
                <div className="step-item">
                  <div className="step-number">2</div>
                  <div className="step-content">
                    <h3>Schedule Consultation</h3>
                    <p>We'll reach out to schedule a detailed consultation call to discuss your specific needs.</p>
                  </div>
                </div>
                <div className="step-item">
                  <div className="step-number">3</div>
                  <div className="step-content">
                    <h3>Custom Solution Design</h3>
                    <p>Based on our discussion, we'll design a tailored AI solution for your business.</p>
                  </div>
                </div>
                <div className="step-item">
                  <div className="step-number">4</div>
                  <div className="step-content">
                    <h3>Implementation & Launch</h3>
                    <p>We'll implement your AI solution and ensure it's working perfectly for your business.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="contact-info">
              <h2>Have Questions?</h2>
              <p>If you need immediate assistance or have urgent questions, feel free to reach out:</p>
              <div className="contact-methods">
                <div className="contact-method">
                  <i className="fas fa-envelope"></i>
                  <div>
                    <h4>Email</h4>
                    <p>contact@codealignr.com</p>
                  </div>
                </div>
                <div className="contact-method">
                  <i className="fas fa-clock"></i>
                  <div>
                    <h4>Response Time</h4>
                    <p>We'll respond within 24 hours</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="cta-buttons">
              <Link to="/" className="btn-primary">Back to Home</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ThankYou;
